import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ConfirmarContaComponent } from './confirmar-conta.component';

@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id/aceite/:aceito', component: ConfirmarContaComponent }
    ])],
    exports: [RouterModule]
})
export class ConfirmarContaRoutingModule { }
